import classNames from 'classnames/bind';
import styles from './srWarning.module.scss';

const cx = classNames.bind(styles);

const SrWarning = () => {
  return (
    <div className={cx('warningWrap')}>
      이 표시가 확인된 경우 미응답한 경우나 응답속도가 너무 빠르거나 늦은 경우일 수 있어요.
      <br />
      스스로의 성향에 맞게끔 솔직하게 성향 파악 과제를 응시하는 것이 가장 좋아요!
    </div>
  );
};

export default SrWarning;
